import { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { getTranslatedItemTitle } from '../prebuilt/config-items/config-items';
export function useLocalizedLatestPrompt(latestPrompt) {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return useMemo(function () {
    return latestPrompt !== null && latestPrompt !== void 0 && latestPrompt.presetTitle ? {
      presetTitle: getTranslatedItemTitle(latestPrompt.presetTitle, formatMessage),
      userInput: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userInput,
      userADFInput: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userADFInput
    } : {
      userInput: (latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userInput) || '',
      userADFInput: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userADFInput
    };
  }, [latestPrompt, formatMessage]);
}